import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		isMobile: /(iPhone|iPad|Android)/ig.test(navigator.userAgent),
		region: environment.region,
		checkoutData: {},
		checkoutId: null,
		checkoutType: null,
		requirePayment: false,
		orderTotal: null,
		paymentOption: [],
		paymentTotal: null,
		paymentUrl: null,
		productId: null,
		error: {},
		deductBalance: null,
		afterBalance: null,
		afterBalanceWithPayment: null,
		currentBalance: 0,
		insufficientBalance: null,
		selectedValue: 'PME002',
		currency: null,
		userData: null,
		sandboxMode: false,
		balance: null,
		showLoadingOverlay: true,
		loadingOverlayLabel: '',
		appType: 'web',
		addBalanceRedirectParams: null,
		channel: null,
	},
	mutations: {
		setChannel(state, payload) {
			state.channel = payload;
		},
		setAppType(state, payload) {
			state.appType = payload;
		},
		setUserData(state, payload) {
			state.userData = payload;
		},
		setData(state, payload) {
			state.checkoutData = { ...payload };
		},
		setProductId(state, payload) {
			state.productId = payload;
		},
		setCheckoutId(state, payload) {
			state.checkoutId = payload;
		},
		setCheckoutType(state, payload) {
			state.checkoutType = payload;
		},
		setRequirePayment(state, payload) {
			state.requirePayment = payload;
		},
		setOrderTotal(state, payload) {
			state.orderTotal = payload;
		},
		setPaymentOption(state, payload) {
			state.paymentOption = payload;
		},
		setPaymentTotal(state, payload) {
			state.paymentTotal = payload;
		},
		setPaymentUrl(state, payload) {
			state.paymentUrl = payload;
		},
		getDeductBalance(state, payload) {
			state.deductBalance = payload;
		},
		getAfterBalance(state, payload) {
			state.afterBalance = payload;
		},
		getCurrentBalance(state, payload) {
			state.currentBalance = payload;
		},
		getInsufficientBalance(state, payload) {
			state.insufficientBalance = payload;
		},
		setCurrency(state, payload) {
			state.currency = payload;
		},
		setAfterBalanceWithRequirePayment(state, payload) {
			state.afterBalanceWithPayment = payload;
		},
		getRegion(state, payload) {
			state.region = payload;
		},
		enableSandboxMode(state) {
			state.sandboxMode = true;
		},
		disableSandboxMode(state) {
			state.sandboxMode = false;
		},
		setBalance(state, payload) {
			state.balance = payload;
		},
		startLoadingOverlay(state, payload) {
			state.loadingOverlayLabel = payload;
			state.showLoadingOverlay = true;
		},
		endLoadingOverlay(state) {
			state.showLoadingOverlay = false;
		},
		setAddBalanceRedirectParams(state, payload) {
			state.addBalanceRedirectParams = payload;
		}
	}
});



// WEBPACK FOOTER //
// ./src/store/index.js